module.exports = __webpack_public_path__ + "6c84e628617608f1234811ee7c613b93.jpg";